import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
    selector: "help-component",
    templateUrl: "./help.component.html",
    styleUrls: ["./help.component.css"],
    standalone: false
})
export class HelpComponent implements OnInit {
  links: any[] = [];

  constructor(
    private http: HttpClient,
    loggedUserService: LoggedUserService,
    route: ActivatedRoute
  ) {}

  ngOnInit(): void {}
}
